import { jsx as i, jsxs as c } from "react/jsx-runtime";
import { BaseButton as E } from "@systemeio/ui";
const d = (n, o, a, s) => {
  const r = o.optionValueIds.map((e) => a.optionValues.map((l) => l.id).includes(e) ? s.id : e);
  return n.productVariants.find(
    (e) => JSON.stringify(e.optionValueIds) === JSON.stringify(r)
  );
}, p = (n, o, a, s) => !!d(n, o, a, s), g = ({ product: n, activeVariant: o, changeActiveVariant: a }) => {
  const s = (t, r) => {
    const e = d(n, o, t, r);
    e && a(e);
  };
  return /* @__PURE__ */ i("div", { className: "flex flex-col gap-2", children: n.options.map((t) => /* @__PURE__ */ c("div", { children: [
    /* @__PURE__ */ i("span", { children: t.name }),
    /* @__PURE__ */ i("div", { className: "flex flex-wrap gap-2", children: t.optionValues.map((r) => {
      const e = o.optionValueIds.includes(r.id);
      return /* @__PURE__ */ i(
        E,
        {
          type: "button",
          onClick: () => s(t, r),
          disabled: !p(n, o, t, r),
          color: e ? "text-THEME-primary" : "text-THEME-text-secondary",
          hoverColor: `hover:${e ? "text-THEME-primary" : "text-THEME-text-secondary"}`,
          backgroundColor: e ? "bg-THEME-tertiary" : "bg-THEME-secondary",
          hoverBackgroundColor: e ? "hover:bg-THEME-tertiary" : "hover:bg-THEME-secondary",
          borderColor: e ? "border-THEME-tertiary" : "border-THEME-border-tertiary",
          children: r.value
        },
        r.id
      );
    }) })
  ] }, t.id)) });
};
export {
  g as Options
};
